export default __webpack_public_path__ + "tier-platinum.svg?e4b7fc177b9d1897fd7dd8906a7ad42c";